import moment from 'moment';

export const isValidShifts = (arrival: string, departure: string) => {
  const format = 'hh:mm a';

  if (!arrival || !departure) {
    return false;
  }

  const tArrival = moment(arrival, format);
  const tDeparture = moment(departure, format);

  if (!tArrival.isValid() || !tDeparture.isValid()) {
    return false;
  }

  return tArrival.isBefore(tDeparture);
};
